import { styled } from '@mui/material/styles';

export const Item = styled('div')(() => ({}));

export const ItemsContainer = styled('div')(({ theme }) => ({
  margin: `0 ${theme.spacing(-1.5)}`,
  [`& ${Item}`]: {
    margin: `0 ${theme.spacing(1.5)}`
  },
  '@media (max-width: 600px)': {
    [`& ${Item}`]: {
      margin: `0 ${theme.spacing(1)}`
    },
    [`& ${Item}#privacyPolicyStatement`]: {
      display: 'inline-block'
    }
  }
}));

export const Section = styled('div')(({ theme, color }) => ({
  alignItems: 'center',
  display: 'flex',
  ...(color === 'primary' && {
    color: theme.color.primary.main
  })
}));

export const Footer = styled('footer')(({ theme }) => ({
  alignItems: 'center',
  color: theme.color.text.light,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingBottom: theme.spacing(2.5),
  paddingTop: theme.spacing(2.5),
  [`& ${Section} + ${Section}`]: {
    margin: `${theme.spacing(2)} 0 0 0`
  },
  '@media (min-width: 600px)': {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    [`& ${Section} + ${Section}`]: {
      borderLeft: '1px solid',
      margin: `0 0 0 ${theme.spacing(3)}`,
      paddingLeft: theme.spacing(3)
    }
  }
}));
